import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import { Deployment } from '@/types/deployment';

async function fetchDeployment(projectId: string, deploymentId: string): Promise<Deployment> {
  console.log('[useDeployment] Fetching deployment:', { projectId, deploymentId });
  // Backend doesn't have individual deployment endpoint, fetch from list
  const response = await api.get<{ data: Deployment[] }>(`/projects/${projectId}/deployments`);
  console.log('[useDeployment] Response:', response.data);
  
  // Find the specific deployment from the list
  const deployment = response.data.data.find(d => d.id === deploymentId);
  if (!deployment) {
    throw new Error(`Deployment ${deploymentId} not found`);
  }
  
  return deployment;
}

export function useDeployment(projectId: string | undefined, deploymentId: string | undefined, enablePolling = false) {
  return useQuery({
    queryKey: ['deployment', projectId, deploymentId],
    queryFn: () => fetchDeployment(projectId!, deploymentId!),
    enabled: !!projectId && !!deploymentId,
    refetchInterval: (query) => {
      // Poll every 2 seconds while building
      const data = query.state.data;
      if (enablePolling && data && (data.status === 'building' || data.status === 'pending')) {
        return 2000;
      }
      return false;
    },
  });
}
